import { TbMath } from 'react-icons/tb';
import commonStore from '../../../../store/common';
import { observer } from 'mobx-react-lite';
import reportStore from '../../store';
import { StyledContainer } from './style';
import { idCreator } from '../../../Project/utils/idCreator';

interface CustomHeaderWithDrillDownProps {
  title: string;
  reportId?: string | number;
  columnName?: string;
  tableName?: string;
  fundId?: string | number;
  tableId?: string | number;
  hasDrillDown?: boolean;
  columnPrettyName?: string;
}

export const CustomHeaderWithDrillDown = observer(
  ({
    title,
    reportId,
    columnName,
    tableName,
    fundId,
    tableId,
    hasDrillDown = true,
    columnPrettyName
  }: CustomHeaderWithDrillDownProps) => {
    const { isConversionReportType } = reportStore;
    return (
      <StyledContainer id={`custom-header-with-drill-down-${idCreator(title)}`}>
        <p id={`custom-header-with-drill-down-title-${idCreator(title)}`}>
          {title.includes('*') ? title.replace('*', '') : title}
          {title.includes('*') && (
            <span id={`custom-header-with-drill-down-required-${idCreator(title)}`}>*</span>
          )}
        </p>
        {hasDrillDown && !isConversionReportType && (
          <div
            className="action-elements"
            id={`custom-header-with-drill-down-actions-${idCreator(title)}`}
          >
            <button
              id={`custom-header-with-drill-down-button-${idCreator(title)}`}
              onClick={() =>
                commonStore.setDrillDown({
                  report_id: reportId,
                  fund_id: fundId,
                  table_name: tableName,
                  column_name: columnName,
                  table_id: tableId,
                  column_pretty_name: columnPrettyName || title
                })
              }
            >
              <TbMath fontSize="15px" color="#7888F5" />
            </button>
          </div>
        )}
      </StyledContainer>
    );
  }
);
